export const config = {
    apiBaseUrl: process.env.REACT_APP_API_URL || '/wp-json/dom/v1/',
};